export enum ComponentTypeEnum {
  societeComposant = 'cmp',
  famille = 'fml'
}
